module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      header: _vm.isHeader
    },
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    ref: "background",
    staticClass: "background"
  }), _vm._v(" "), _c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('svg', {
    ref: "svg",
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 552 45",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "name"
    }
  }, [_c('text', {
    attrs: {
      "x": "0.499px",
      "y": "43.8px"
    }
  }, [_vm._v("Alex van Vliet")]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M29.344,43.8l8.797,0l-14.229,-43.2l-8.796,0l9.091,27.603l-9.641,-0.02l4.876,-14.448l-8.797,0l-10.146,30.065l8.797,0l2.459,-7.288l15.199,0.031l2.39,7.257l0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.68,26.8l0,8.06l-20.048,0l0,-34.26l-8.797,0l0,43.2l37.642,0l0,-17l-8.797,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.171,0.6l0,8.599l37.642,0l0,-8.599l-37.642,0Zm8.797,25.858l19.835,0l0,-8.599l-28.632,0l0,25.941l37.642,0l0,-8.599l-28.845,0l0,-8.743Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M148.655,16.517l6.844,0l9.641,-15.917l-8.796,0l-8.664,14.303l-8.647,-14.303l-11.526,0l16.494,27.283l-6.852,0l-9.642,15.917l8.797,0l8.668,-14.31l8.651,14.31l11.526,0l-16.494,-27.283l0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M231.317,0.6l-8.797,0l-10.159,30.025l-9.889,-30.025l-8.797,0l14.228,43.2l8.797,-0.001l14.617,-43.199l0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M264.856,43.8l8.797,0l-14.229,-43.2l-8.796,0l9.091,27.603l-9.641,-0.02l4.876,-14.448l-8.797,0l-10.146,30.065l8.797,0l2.459,-7.288l15.199,0.031l2.39,7.257l0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M307.192,0.635l0,29.991l-20.048,-30.026l-8.797,0.035l0,43.165l8.797,0l0,-30.026l20.048,30.026l8.797,0l0,-43.165l-8.797,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M382.157,0.6l-8.797,0l-10.159,30.025l-9.889,-30.025l-8.797,0l14.228,43.2l8.797,-0.001l14.617,-43.199l0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M415.696,26.8l0,8.06l-20.048,0l0,-34.26l-8.797,0l0,43.2l37.642,0l0,-17l-8.797,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M466.828,9.317l0,-8.715l-37.641,0l0,8.715l14.527,0l0,25.768l-14.526,0l0,8.715l37.64,0l0,-8.715l-14.526,0l0,-25.768l14.526,0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M471.523,0.6l0,8.599l37.642,0l0,-8.599l-37.642,0Zm8.797,25.858l19.835,0l0,-8.599l-28.632,0l0,25.941l37.642,0l0,-8.599l-28.845,0l0,-8.743Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M513.859,0.602l0,8.604l14.423,0l0,34.594l8.796,0l0,-34.594l14.423,0l0,-8.604l-37.642,0l0,0Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    ref: "balls",
    staticClass: "loader"
  }, [_c('div', {
    ref: "ball1",
    staticClass: "ball ball-1",
    staticStyle: {
      "left": "0%",
      "transform": "translateX(0)"
    }
  }), _vm._v(" "), _c('div', {
    ref: "ball2",
    staticClass: "ball ball-2",
    staticStyle: {
      "left": "50%",
      "transform": "translateX(0)"
    }
  })]), _vm._v(" "), _c('svg', {
    ref: "glitch",
    attrs: {
      "id": "glitch",
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 552 46",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "glitch-filter"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "black",
      "result": "black"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": "red",
      "result": "flood1"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": "limegreen",
      "result": "flood2"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "in": "SourceGraphic",
      "dx": "3",
      "dy": "0",
      "result": "off1a"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "in": "SourceGraphic",
      "dx": "2",
      "dy": "0",
      "result": "off1b"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "in": "SourceGraphic",
      "dx": "-3",
      "dy": "0",
      "result": "off2a"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "in": "SourceGraphic",
      "dx": "-2",
      "dy": "0",
      "result": "off2b"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "flood1",
      "in2": "off1a",
      "operator": "in",
      "result": "comp1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "flood2",
      "in2": "off2a",
      "operator": "in",
      "result": "comp2"
    }
  }), _vm._v(" "), _c('feMerge', {
    attrs: {
      "x": "0",
      "width": "100%",
      "result": "merge1",
      "y": "104px",
      "height": "1.43076px"
    }
  }, [_c('feMergeNode', {
    attrs: {
      "in": "comp1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "off1b"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "y",
      "id": "y",
      "dur": "4s",
      "values": "104px; 104px; 30px; 105px; 30px; 2px; 2px; 50px; 40px; 105px; 105px; 20px; 6ßpx; 40px; 104px; 40px; 70px; 10px; 30px; 104px; 102px",
      "keyTimes": "0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "height",
      "id": "h",
      "dur": "4s",
      "values": "10px; 0px; 10px; 30px; 50px; 0px; 10px; 0px; 0px; 0px; 10px; 50px; 40px; 0px; 0px; 0px; 40px; 30px; 10px; 0px; 50px",
      "keyTimes": "0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1",
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('feMerge', {
    attrs: {
      "x": "0",
      "width": "100%",
      "y": "98.9108px",
      "height": "3.63849px",
      "result": "merge2"
    }
  }, [_c('feMergeNode', {
    attrs: {
      "in": "comp2"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "off2b"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "y",
      "id": "y",
      "dur": "4s",
      "values": "103px; 104px; 69px; 53px; 42px; 104px; 78px; 89px; 96px; 100px; 67px; 50px; 96px; 66px; 88px; 42px; 13px; 100px; 100px; 104px;",
      "keyTimes": "0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513; 0.548; 0.577; 0.613; 1",
      "repeatCount": "indefinite"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "height",
      "id": "h",
      "dur": "4s",
      "values": "0px; 0px; 0px; 16px; 16px; 12px; 12px; 0px; 0px; 5px; 10px; 22px; 33px; 11px; 0px; 0px; 10px",
      "keyTimes": "0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513;  1",
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "merge1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "merge2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "193.675px",
      "y": "44.8px"
    }
  }, [_vm._v("\n\t\t\t\tSoon\n\t\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fdf71b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 35
// module chunks = 1